import * as React from 'react';
import MuiAccordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));


const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
  backgroundColor: 'rgb(255, 255, 255)'
}));

export default function MemoryMobile({ item, handleOpen}) {
    let metadata = () => {
      if (item.metadata != undefined) {
        return (<div style={{paddingLeft:'10px'}}><a role="link" onClick={(e) => handleOpen(e, item)}>Ver fuente <span className="more-info" title="Ver página y texto usados para dar este resultado.">(?)</span></a></div>);
      }
      else return null;
    }
    return (
      <tr id='memory' className='Memory'>
        <td colSpan={5}>
          <div style={{paddingBottom:'10px'}}>
            <a href={item.link} style={{color:'#000000'}} target="_blank" rel="noreferrer">
              <div style={{paddingTop:'10px',paddingLeft:'10px',paddingRight:'10px'}}>
                {item.name}
                <br />
                <button  type="button" disabled style={{marginRight:10}}>
                  {item.date}
                </button>
                <button  type="button" disabled style={{marginRight:10}}>
                  {item.university.toUpperCase()}
                </button>
                <button  type="button" disabled>
                  {item.author}
                </button>
                <br />
              </div>
            </a>
            {metadata()}
          </div>
        </td>
      </tr>
    )
  }